import React, { useState } from 'react';
import { Box } from '@material-ui/core';
import TopBar from './components/TopBar';
import ForgotPasswordForm from './components/ForgotPasswordForm';
import ResetPasswordForm from './components/ResetPasswordForm';
import { useIsDesktop } from '../../components/utilities';

const ForgotPassword = () => {
	const [step, setStep] = useState(0);
	const [userPhone, setUserPhone] = useState(null);

	const nextStep = (phone) => {
		setUserPhone(phone);
		setStep(1);
	};

	const isDesktop = useIsDesktop();

	return (
		<Box>
			<TopBar />
			<Box p={isDesktop ? 3 : 0}>
				{step === 0 ? (
					<ForgotPasswordForm goNext={nextStep} />
				) : (
					<ResetPasswordForm phoneObject={userPhone} />
				)}
			</Box>
		</Box>
	);
};

export default ForgotPassword;
